export async function getFileSize(input) {
  if (typeof input === 'string') {
    try {
      const res = await fetch(input, { method: 'HEAD' });
      const size = res.headers.get('Content-Length');
      return size ? parseInt(size) : null;
    } catch {
      return null;
    }
  } else if (input && input.raw instanceof Blob) {
    return input.raw.size;
  }
  return null;
}

export default function getVideoMes(input) {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');

    // 兼容文件和url
    if (typeof input === 'string') {
      video.src = input;
    } else if (input && input.raw instanceof Blob) {
      video.src = URL.createObjectURL(input.raw);
    } else {
      reject(new Error('Invalid input: expected URL string or File object'));
      return;
    }

    video.addEventListener('loadeddata', async () => {
      try {
        const result = {
          videoWidth: video.videoWidth,
          videoHeight: video.videoHeight,
          isVideoH264: !!video.canPlayType('video/mp4; codecs="avc1.64001E"'),
          duration: video.duration,
        };
        console.log(result, 'result');
        resolve(result);
      } catch (error) {
        reject(error);
      } finally {
        if (video.src.startsWith('blob:')) {
          URL.revokeObjectURL(video.src);
        }
      }
    });

    video.addEventListener('error', () => {
      if (video.src.startsWith('blob:')) {
        URL.revokeObjectURL(video.src);
      }
      reject(new Error('Failed to load video metadata'));
    });
  });
}
